import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ModalWindow from '../../common/Modal';
import styles from './RetailerIdsListModal.module.scss';

export function RetailerIdsListModal(props) {
  const { open, onClose } = props;
  const supplierRetailers = useSelector((state) => state.role.supplier.supplier_retailers);
  const retailers = useMemo(() => supplierRetailers.map((sp) => sp.retailer), [supplierRetailers]);

  const closeModal = () => {
    onClose(false);
  };

  return (
    <ModalWindow open={open} onClose={closeModal} showCloseIcon={true} size="large" center>
      <h2>Retailers IDs</h2>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Retailer Name</th>
            <th>Retailer ID</th>
          </tr>
        </thead>
        <tbody>
          {retailers.map((retailer) => (
            <tr key={retailer.id}>
              <td>{retailer.name.split('-')[0].trim()}</td>
              <td className={styles.retailerId}>{retailer.id}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={styles.footer}>
        <button className={styles.button} onClick={onClose}>
          Close
        </button>
      </div>
    </ModalWindow>
  );
}

export default RetailerIdsListModal;

RetailerIdsListModal.defaultProps = {
  open: false,
};

RetailerIdsListModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};
